import formatter from "@/kuaa/kuaa-formatter";

// 기부자 관리 탭 컬럼
const Columns = {

  // 장학생 매칭
  'tab1' : [
    // {header: '장학생 매칭', name: 'schaAmount', align : 'center',
    //   formatter(value) {
    //     return '<button style="cursor: pointer" class="btn-donator-matching">장학생 매칭</button>';
    //   }
    // },
    {header: '지급구분', name: 'applyGbNm', align : 'center'},
    {header: '성명', name: 'nm', align : 'center'},
    {header: '생년월일', name: 'bornYm', align : 'center'},
    {header: '대학', name: 'collegeMCdNm', align : 'center'},
    {header: '학과', name: 'collegeSCdNm', align : 'center'},
    {header: '학번', name: 'schaHakbun', align : 'center'},
    {header: '학년', name: 'collegeSemesterCdNm', align : 'center'},
    {header: '학생지급액', name: 'kuaaAmount', align : 'center',
      formatter(value) {
        let total = value.row.schaAmount + value.row.kuaaAmount + value.row.reserveAmount;
        return isNaN(total) ? '' : formatter.getCurrency(total);
      }
    },
    {header: '비고', name: 'etc', align : 'center'},
    {header: '', name: 'semesterCd', hidden:true},
    {header: '', name: 'applyGb', hidden:true},
    {header: '', name: 'collegeSemesterCdNm', hidden:true},
    {header: '', name: 'tuitionAmount', hidden:true}
  ],

  // 기부액
  'tab2' : [
    {header: '기부학기', name: 'semesterCd', align : 'center'},
    {header: '실입금액', name: 'giveAmount', align : 'center',
      formatter(value) {
        return value.value ? formatter.getCurrency(value.value) : '';
      }
    },
    {header: '지급방법', name: 'designateGb', align : 'center'},
  ],

  // 지급 명단
  'tab3' : [
    {header: '지급학기', name: 'semesterCd', align : 'center'},
    {header: '교우번호', name: 'applyMemberNo', align : 'center'},
    {header: '성명', name: 'nm', align : 'center'},
    {header: '생년월일', name: 'bornYm', align : 'center'},
    {header: '대학', name: 'collegeMCdNm', align : 'center'},
    {header: '학과', name: 'collegeSCdNm', align : 'center'},
    {header: '학번', name: 'schaHakbun', align : 'center'},
    {header: '학년', name: 'collegeSemesterCdNm', align : 'center'},
    {header: '지급액', name: 'schaAmount', align : 'center',
      formatter(value) {
        let total = value.row.schaAmount + value.row.kuaaAmount + value.row.reserveAmount;
        return isNaN(total) ? '' : formatter.getCurrency(total);
      }
    },
    {header: '지급구분', name: 'giveGbNm', align : 'center'},
    {header: '비고', name: 'etc', align : 'center'},
    {header: '', name: 'applyGb', hidden:true}
  ],

  // 지급 특성
  'tab4' : [
    {header: '학기', name: 'semesterCd', align : 'center'},
    {header: '지급조건', name: 'conditionGive', align : 'center'},
    {header: '세부조건', name: 'conditionDetail', align : 'center'},
    {header: '비고', name: 'conditionEtc', align : 'center'}
  ],

  // 추천관계자
  'tab5' : [
    {header: '학기', name: 'semesterCd', align : 'center'},
    {header: '학장', name: 'recomDean', align : 'center'},
    {header: '부장(차장)', name: 'recomDirector', align : 'center'},
    {header: '담당자', name: 'recomManager', align : 'center'}
  ],

  // 재학중 수혜내역
  'tab6' : [
    {header: '수혜년도 및 학기', name: 'semesterCd', align : 'center'},
    {header: '수혜학년', name: 'collegeSemesterCd', align : 'center'},
    {header: '구분', name: 'giveGb', align : 'center'},
    {header: '지급교우교우번호', name: 'memberrNo', align : 'center'},
    {header: '지급교우', name: 'memberHnm', align : 'center'},
    {header: '비고', name: 'etc', align : 'center'}
  ],

  // 학기별 약정내역
  'tab7' : [
    {header: '대학학기', name: 'semesterCd', align : 'center'},
    {header: '약정서', name: 'agreemFileDir', align : 'center'},
    {header: '섭외담당자', name: 'agreemFindmanCd', align : 'center'},
    {header: '직접지명', name: 'agreemExecDesignate', align : 'center'},
    {header: '교우회 위임', name: 'agreemExecMendateGb', align : 'center'},
    {header: '특수관계인', name: 'agreemExecEtc', align : 'center'},
    {header: '기타', name: 'semesterCd', align : 'center'},
    {header: '비고', name: 'agreemEtc', align : 'center'}
  ],

  // 담당자
  'tab8' : [
    {header: '대학학기', name: 'semesterCd', align : 'center'},
    {header: '직장명', name: 'companyName', align : 'center'},
    {header: '직위', name: 'levelNm', align : 'center'},
    {header: '실무담당자', name: 'managerNm', align : 'center'},
    {header: '이메일', name: 'eMail', align : 'center'},
    {header: '책입자', name: 'secNm', align : 'center'},
    {header: '부서직위', name: 'secPosition', align : 'center'},
    {header: '직장전화', name: 'officePhone', align : 'center'},
    {header: '핸드폰', name: 'celluar', align : 'center',
    formatter(value) {
        return value.value != null ? formatter.getPhoneMask(value.value) : value.value;
    }},
    {header: '특이사항', name: 'etc', align : 'center'},
    {header: '기부영수증', name: 'receiptGb', align : 'center'},
    {header: '발송주소', name: '', align : 'center', width: 250,
      formatter(value) {
        //set value.row.agreemZipcd = '' if null
        if (value.row.agreemZipcd == null) {
          value.row.agreemZipcd = '';
        }
        //set value.row.agreemAddress1 = '' if null
        if (value.row.agreemAddress1 == null) {
          value.row.agreemAddress1 = '';
        }
        //set value.row.agreemAddress2 = '' if null
        if (value.row.agreemAddress2 == null) {
          value.row.agreemAddress2 = '';
        }

        return value.row.agreemZipcd + value.row.agreemAddress1 + value.row.agreemAddress2;
      }
    }
  ],

  //주요변동사항
  'tab9' : [
    {header: '연락자', name: 'contactPerson', align : 'center', width: 150},
  {
    header: '일자', 
    name: 'contactDate', 
    align : 'center', 
    width: 150,
    formatter(value) {
      // 8자리 숫자를 YYYY-MM-DD 형식으로 변환
      if (value.value && value.value.length === 8) {
        return value.value.substr(0,4) + '-' + value.value.substr(4,2) + '-' + value.value.substr(6,2);
      }
      return value.value;
    }
  },
    {header: '작성자', name: 'userNm', align : 'center', width: 150},
    {header: '내용', name: 'contents', align : 'left', className: 'pre-line-cell',}
  ]

};
export default Columns;
